import { TConnection } from '../../../../../../../api/blueprints/connection.template.types';
import { configList, FieldKey } from './connection-audio-bridge-form.config';
import { BaseConnectionFormVM } from '../base-connection-form.viewmodel';
import { Container } from 'typescript-ioc';
import { IZoomDAO, IZoomTelephoneNumberSetDTO } from '../../../../../../../api/zoom.dao';
import { observable, runInAction } from 'mobx';
import { AudioBridgeProvider } from '../../../../../../../api/connections.dao';
import { AudioBridgeProviderLabel } from '../../../../../../../infrastructure/utils/common.utils';
import { TObject } from '../../../../../../../infrastructure/type-extensions';
import { DEFAULT_GET_PAGING_PARAMS } from '../../../../../../../constants/pagination.contants';
import { ConnectionVersion } from '../../../../../../../constants/common.constants';
import { FormVmItemConfigType } from '../../../../../../../infrastructure/form-viewmodel-controller';

export enum ConfernceModeValues {
    HOSTS_ONLY = 'Hosts Only',
    PRESENTATION = 'Presentation',
    Q_AND_A = 'Q&A',
    CONVERSATION = 'Conversation'
}

export class ConnectionAudioBridgeFormVM extends BaseConnectionFormVM {
    @observable
    private telephoneNumberSets: IZoomTelephoneNumberSetDTO[] = [];

    constructor(
        protected connection: TConnection,
        protected readonly addConnection: (connection: TConnection) => void,
        protected readonly editConnection: (connection: TConnection) => void,
        protected readonly connectionVersion: ConnectionVersion,
        protected readonly isAutoSyncLimitReached: boolean,
        private readonly zoomDao: IZoomDAO = Container.get(IZoomDAO),
    ) {
        super(connection, ConnectionAudioBridgeFormVM.buildConfigList(connection), addConnection, editConnection, connectionVersion);
    }

    private static buildConfigList(connection?: TConnection): FormVmItemConfigType[] {
        if (!connection) {
            return configList;
        }
        return configList.map(item =>
            item.name === FieldKey.AUTOMATICALLY_RECORD_ENABLED
                ? { ...item, defaultValue: false }
                : item
        );
    }

    public get numberSets(): TObject[] {
        return this.telephoneNumberSets
            .filter((numberSet: IZoomTelephoneNumberSetDTO) => numberSet.provider === AudioBridgeProvider.TURBOBRIDGE)
            .map((numberSet: IZoomTelephoneNumberSetDTO) => ({
                value: numberSet.id,
                label: `${AudioBridgeProviderLabel[numberSet.provider]}: ${numberSet.name}`
            }));
    }

    public get providers(): TObject[] {
        return Object.entries(AudioBridgeProviderLabel)
            .map(([value, label]) => ({ value: value, label: label }));
    }

    public get conferenceModeOptions(): TObject<ConfernceModeValues>[] {
        return Object.keys(ConfernceModeValues).map((key: ConfernceModeValues) => {
            return { label: ConfernceModeValues[key], value: key };
        });
    }

    public get isLimitReached(): boolean {
        return this.isAutoSyncLimitReached;
    }

    public async initialize(): Promise<void> {
        await this.getTelephoneNumberSets();
    };

    private getTelephoneNumberSets = async (): Promise<void> => {
        try {
            const response = await this.zoomDao.getTelephoneNumberSets(DEFAULT_GET_PAGING_PARAMS);
            runInAction(() => {
                this.telephoneNumberSets = response.content;
            });
        } catch (e) {
            BaseConnectionFormVM.handleApiException(e);
        }
    };
}
